import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        background: theme.palette.primary.light,
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
    },
    logo: {
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(3.5),
        },
    },
    copyRightWrapper: {
        marginBottom: theme.spacing(3),
    },
    rightsReservedText: {},
    copyRightText: {
        fontWeight: '400',
    },
    appleStoreButtonWrapper: {
        marginBottom: theme.spacing(1),
    },
    menuItem: {
        display: 'block',
        marginBottom: theme.spacing(4),
        transition: 'color 0.5s',
        '&:hover': {
            color: theme.palette.logo.purple.main,
        },
        [theme.breakpoints.down('lg')]: {
            marginBottom: theme.spacing(2),
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.1rem',
            marginBottom: theme.spacing(1),
            // textDecoration: 'underline',
        },
    },
    bottomWrapper: {
        marginTop: theme.spacing(10),
        [theme.breakpoints.down('sm')]: { marginTop: 0 },
    },
    bottomSocialWrapper: {
        textAlign: 'right',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'left',
            marginTop: theme.spacing(6),
        },
    },
    bottomSocialLinkWrapper: {
        width: 25,
        height: 25,
        marginRight: theme.spacing(2),
    },
    bottomSocialLink: {
        color: theme.palette.primary.dark,
        fontSize: 14.75,
        '&:hover': {
            color: theme.palette.logo.purple.main,
        },
    },
}));
